'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib = require('tslib');
var jsxRuntime = require('react/jsx-runtime');
var react = require('react');
var cx = require('classnames');
var Skeleton_module = require('./Skeleton.module.scss.js');
var SkeletonLoader_types = require('./SkeletonLoader.types.js');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var cx__default = /*#__PURE__*/_interopDefault(cx);

var SkeletonLoader = function (_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b, _c = _a.tag, tag = _c === void 0 ? SkeletonLoader_types.DEFAULT_TAG : _c, props = tslib.__rest(_a, ["className", "tag"]);
    var Tag = tag;
    return jsxRuntime.jsx(Tag, tslib.__assign({ className: cx__default.default(Skeleton_module.default['skeleton-loader'], className) }, props));
};
var SkeletonLoader$1 = react.memo(SkeletonLoader);

exports.default = SkeletonLoader$1;
//# sourceMappingURL=SkeletonLoader.js.map
